import React from 'react';
import {Styles} from '../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import axios from "axios";
import {defaultVariabls} from "../../../config/index";
import {connect} from "trim-redux";
import {withRouter} from "react-router-dom";
import { withSnackbar } from 'notistack';
import Container from "@material-ui/core/Container/Container";
import {Translate} from "../../../config/Translate";
import withWidth from "@material-ui/core/withWidth/withWidth";
import AppCardLoaderFields from "../../components/Skeletons/AppCardLoaderFields";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from "@material-ui/core";
import moment from "jalali-moment";
import Grid from "@material-ui/core/Grid/Grid";
import ChooseDate from "../../components/elements/ChooseDate";
import TextField from "@material-ui/core/TextField/TextField";
import InputAdornment from "@material-ui/core/InputAdornment/InputAdornment";
import SearchRoundedIcon from "@material-ui/icons/SearchRounded";
import IconButton from "@material-ui/core/IconButton/IconButton";
import {ChevronLeftRounded} from "@material-ui/icons";
import Button from "@material-ui/core/Button/Button";
import PublishRoundedIcon from '@material-ui/icons/PublishRounded';
import PrintRoundedIcon from '@material-ui/icons/PrintRounded';
import SubTitle from "../../components/elements/SubTitle";

class AccountingReport extends React.Component {
    constructor(props) {
        super(props)
    }
    classes = this.props.classes;
    state = {
        data: [],
        loading:true,
        remove:false,
        beginDate: '',
        endDate: '',
        search: '',
    };
    componentDidMount() {
        this.loadData()
    }

    loadData(){
        this.setState({
            loading:true
        })
        let {beginDate,endDate,search} = this.state;
        let loginToken = localStorage.getItem('ACT');
        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        let data = new FormData();
        data.append('beginDate', beginDate);
        data.append('endDate', endDate);
        data.append('search', search);
        data.append('manage', !!this.props.manage ? 1 : 0);
        data.append('id', !!this.props.manage ? this.props.match.params.id : 0);

        axios.post(`${defaultVariabls.url}/accounting/report`,data, config)
            .then(response => {
                this.setState({
                    data:response.data,
                    loading:false,
                })
            })
            .catch(error => {
                console.log(error.response);
                this.props.enqueueSnackbar(Translate.errorHappens, {
                    variant: 'error',
                });

            });
    }

    async handleBeginDate(beginDate){
        await this.setState({
            beginDate,
        })
        await this.loadData();
    }
    async handleEndDate(endDate){
        await this.setState({
            endDate
        })
        await this.loadData();
    }
    handleSearch(search){
        this.setState({
            search
        })

    }
    async removeFilter(){
        await this.setState({
            search:'',
            beginDate:'',
            endDate:'',
            remove:true,
        })
        await this.loadData();

        await this.setState({
            remove:false,
        })

    }
    render(){
        let {data,search,beginDate,endDate,remove} = this.state;
        let shop_name = this.props.match?.params?.name;
        let {manage} = this.props;
        let id = !!this.props.manage ? this.props.match.params.id : 0;
        return (
            <>
                {
                        <Container maxWidth="xl">
                            <Grid container spacing={2}>
                                {
                                    !remove &&
                                    <Grid item xs={12}>
                                        <Grid container direction="row"  alignItems="center" className={this.classes.filterContainer}>
                                            {
                                                manage &&
                                                <Grid item xs={12}>
                                                    <SubTitle align="left">{Translate.accountingReport} {Translate.shop} {shop_name}</SubTitle>
                                                </Grid>
                                            }
                                            <Grid item xs={12}>
                                                <Grid container spacing={2} alignItems="center" direction="row" >
                                                    <Grid item xs={6} md={3}>
                                                        <ChooseDate
                                                            handleDate={this.handleBeginDate.bind(this)}
                                                            label={Translate.chooseBeginDate}
                                                            variant="outlined"
                                                            noMargin
                                                        />
                                                    </Grid>
                                                    <Grid item xs={6} md={3}>
                                                        <ChooseDate
                                                            handleDate={this.handleEndDate.bind(this)}
                                                            label={Translate.chooseEndDate}
                                                            variant="outlined"
                                                            noMargin
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} md={3}>
                                                        <TextField
                                                            fullWidth
                                                            variant="outlined"
                                                            size="small"
                                                            name="search"
                                                            InputProps={{
                                                                endAdornment: (
                                                                    <InputAdornment position="end">
                                                                        <IconButton
                                                                            size="small"
                                                                            onClick={() => this.loadData()}
                                                                        >
                                                                            <ChevronLeftRounded />
                                                                        </IconButton>

                                                                    </InputAdornment>
                                                                ),
                                                            }}
                                                            label={Translate.factor_number}
                                                            type="text"
                                                            value={search}
                                                            onChange={(e) => this.handleSearch(e.target.value)}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} md={3} style={{display:"flex",gap:10}}>
                                                        <Button
                                                            size="small"
                                                            component="a"
                                                            color="primary"
                                                            variant="contained"
                                                            startIcon={<PublishRoundedIcon/>}
                                                            href={`${defaultVariabls.website}/export-accounting-report?beginDate=${beginDate}&endDate=${endDate}&search=${search}${!!manage ? `&manage=${manage}&id=${id}` : ""}`}
                                                        >
                                                            {Translate.exportInExcel}
                                                        </Button>
                                                        <Button
                                                            size="small"
                                                            component="a"
                                                            target="_blank"
                                                            color="primary"
                                                            variant="contained"
                                                            startIcon={<PrintRoundedIcon/>}
                                                            href={`${defaultVariabls.website}/accounting-report?beginDate=${beginDate}&endDate=${endDate}&search=${search}${!!manage ? `&manage=${manage}&id=${id}` : ""}`}
                                                        >
                                                            {Translate.print}
                                                        </Button>
                                                    </Grid>
                                                        {
                                                            (!!beginDate || !!endDate || !!search) &&
                                                            <Grid item xs={6} md={2}>
                                                                <Button
                                                                    size="small"
                                                                    onClick={() => this.removeFilter()}
                                                                >
                                                                    {Translate.removeFilter}
                                                                </Button>
                                                            </Grid>
                                                        }
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                }

                                <Grid item xs={12} style={{minHeight:500}}>
                                    {
                                        this.state.loading ? <AppCardLoaderFields/> :
                                            <TableContainer  style={{ maxWidth: "100%", border: "1px solid #ccc" }}>
                                                <Table>
                                                    <TableHead>
                                                        <TableRow style={{ backgroundColor: "#f5f5f5" }}>
                                                            <TableCell style={styles.header}>{Translate.index}</TableCell>
                                                            <TableCell style={styles.header}>{Translate.date}</TableCell>
                                                            <TableCell style={styles.header}>{Translate.describe}</TableCell>
                                                            <TableCell style={styles.header}>{Translate.debit}</TableCell>
                                                            <TableCell style={styles.header}>{Translate.credit}</TableCell>
                                                            <TableCell style={styles.header}>{Translate.debitCredit}</TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {data.length > 0 ? (
                                                            data.map((row, index) => (
                                                                <TableRow key={index} style={index % 2 === 0 ? styles.evenRow : styles.oddRow}>
                                                                    <TableCell style={styles.cell}>{row.row}</TableCell>
                                                                    <TableCell style={styles.cell}>{moment(row.date).locale('fa').format( 'YYYY/M/D')}</TableCell>
                                                                    <TableCell style={styles.cell}>{row.description}</TableCell>
                                                                    <TableCell style={styles.cell} dir="ltr" >{row.debit > 0 ? row.debit.toLocaleString() : ""}</TableCell>
                                                                    <TableCell style={styles.cell} dir="ltr" >{row.credit > 0 ? row.credit.toLocaleString() : ""}</TableCell>
                                                                    <TableCell dir="ltr" style={{ fontWeight: "bold",border:"1px solid #ddd" }}>{row.balance.toLocaleString()}</TableCell>
                                                                </TableRow>
                                                            ))
                                                        ) : (
                                                            <TableRow>
                                                                <TableCell colSpan={6} style={{ textAlign: "center", padding: "20px", fontSize: "16px" }}>
                                                                    {Translate.noResultFound}
                                                                </TableCell>
                                                            </TableRow>
                                                        )}
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                    }
                                </Grid>
                            </Grid>
                        </Container>
                }
            </>

        );
    }
}
const styles = {
    header: {
        fontWeight: "bold",
        border:"1px solid #ddd",
        borderBottom: "2px solid #ddd",
    },
    evenRow: {
        backgroundColor: "#fff",
    },
    oddRow: {
        backgroundColor: "#f9f9f9",
    },
    cell:{
        border:"1px solid #ddd"
    }
};
const mstp = state => ({
    locale: state.locale,
});
export default withWidth()(withSnackbar(withRouter(withStyles(Styles)(connect(mstp)(AccountingReport)))));